import { render, staticRenderFns } from "./CreateEditCategory.vue?vue&type=template&id=65fe00b8"
import script from "./CreateEditCategory.vue?vue&type=script&lang=js"
export * from "./CreateEditCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateEditCategory.vue?vue&type=style&index=0&id=65fe00b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports